import React, { FunctionComponent, useEffect, useState } from 'react';
import { getGranulesStatus } from '../../services/GranuleService';
import './GranulesSummary.css';

type GranulesSummaryProps = {
  kapsuleId: string
};

type GranulesSummaryBlockProps = {
  title: string;
  value: number;
  withBorders?: boolean;
};

type GranulesStatus = {
  total: number,
  reloaded: number,
  unreloaded: number
}

const GranulesSummaryBlock: FunctionComponent<GranulesSummaryBlockProps> = ({ title, value, withBorders }) => {
  return (
    <div className={withBorders ? 'granules-summary-block with-borders' : 'granules-summary-block'}>
      {title}
      <br />
      <br />
      {value}
    </div>
  );
};

export const GranulesSummary: FunctionComponent<GranulesSummaryProps> = ({kapsuleId}) => {
  const [granulesStatus, setGranulesStatus] = useState<GranulesStatus>({
    total: 0,
    reloaded: 0,
    unreloaded: 0
  });

  useEffect(() => {
    reloadGranulesStatus(kapsuleId)
  }, [kapsuleId]);

  const reloadGranulesStatus = async (kapsuleId: string) => {
    try {
      const granulesStatus = await getGranulesStatus(kapsuleId);
      setGranulesStatus(granulesStatus);
    } catch (e) {
      setGranulesStatus({
        total: 0,
        reloaded: 0,
        unreloaded: 0
      });
    }
  }

  return (
    <div className="granules-summary-container">
      <GranulesSummaryBlock title="Total Records" value={granulesStatus.total} />
      <GranulesSummaryBlock withBorders title="Reloaded" value={granulesStatus.reloaded} />
      <GranulesSummaryBlock title="Not Reloaded" value={granulesStatus.unreloaded} />
    </div>
  );
};
